import React from "react";
import { dateFormat } from "../../helper";
import { format } from "date-fns";
import style from "../style.less";

export const HistoryItem = ({
  oldValue,
  newValue,
  fieldName,
  createdAt,
  getNameTemplate,
}) => {
  switch (fieldName) {
    case "created":
      return (
        <>
          <span className={style.dateStyle}>{dateFormat(createdAt)}</span>{" "}
          <span>Создание договора</span>
        </>
      );
    case "accountStartDate":
      return itemHistory({
        message: "Начало действия счета",
        createdAt,
        oldValue,
        newValue,
      });
    case "closeDateForIS":
      return itemHistory({
        message: "Дата закрытия для ИС",
        createdAt,
        oldValue,
        newValue,
      });
    case "contractNumber":
      return itemHistory({
        message: "Изменение номера договора",
        createdAt,
        oldValue,
        newValue,
      });
    case "avtovazBank":
      return itemHistory({
        message: "Изменение банка",
        createdAt,
        oldValue,
        newValue,
      });
    case "avtovazAccount":
      return itemHistory({
        message: "Изменение счёта",
        createdAt,
        oldValue,
        newValue,
      });
    case "ursosSignedDate":
      return itemHistory({
        message: "Дата подписи УРСоС",
        createdAt,
        oldValue,
        newValue,
      });
    case "dealerSignedDate":
      return itemHistory({
        message: "Подписано дилером",
        createdAt,
        oldValue,
        newValue,
      });
    case "workStartDate":
      return itemHistory({
        message: "Дата включения в работу",
        createdAt,
        oldValue,
        newValue,
      });
    case "contractDate":
      return itemHistory({
        message: "Дата договора",
        createdAt,
        oldValue,
        newValue,
      });
    case "printFormId":
      return itemHistory({
        message: "Змена шаблона печати",
        createdAt,
        oldValue,
        newValue,
        getNameTemplate: getNameTemplate,
        nameMessage: "printFormId",
      });
    default:
      return itemHistory({ message: fieldName, createdAt, oldValue, newValue });
  }
};
const itemHistory = ({
  message,
  createdAt,
  oldValue,
  newValue,
  getNameTemplate,
  nameMessage,
}: {
  message: string;
  createdAt: Date | string;
  oldValue: Date | null | undefined | string;
  newValue: string;
  getNameTemplate?: (id: number) => string;
  nameMessage?: string;
}) => {
  const checkDate = (prop) => {
    return prop.endsWith("Z");
  };
  const formatDate = (prop) => {
    return format(new Date(prop.split("T")[0]), "dd.MM.yyyy");
  };
  return (
    <>
      <span className={style.dateStyle}>{dateFormat(createdAt) ?? ""}</span>{" "}
      {message}{" "}
      {nameMessage === "printFormId"
        ? getNameTemplate(Number(oldValue))
        : checkDate(oldValue)
        ? formatDate(oldValue)
        : oldValue ?? ""}
      &rArr;
      {nameMessage === "printFormId"
        ? getNameTemplate(Number(newValue))
        : checkDate(newValue)
        ? formatDate(newValue)
        : newValue ?? ""}
    </>
  );
};
